import { useState } from "react";
import {
  Button,
  ModalDelete,
  ModalUpload,
  ModalPreview,
} from "expano-components";
import { url } from "utils/api";
import GlobalImageModal from "./GlobalImageModal";

import { ReactComponent as GlobalImageIcon } from "icons/global-image.svg";
import classNames from "classnames";
import { ReactComponent as EditIcon } from "icons/edit.svg";
import EditFileNameModal from "./EditFileNameModal";

const SingleImageRow = ({
  id,
  image,
  handleDelete,
  handleUpdate,
  handleSetGlobalImage,
  handleSetProductNeutralImage,
  handleSetProductForBundleImage,
  handleSetProductAiImage,
  handleRenameImage,
  is_global,
  product_data,
  handleSetActiveImage,
  is_checked,
  is_neutral,
  is_for_bundle,
  is_generated_by_ai,
  image_filename,
}) => {
  const [is_loading_for_bundle, setLoadingForBundle] = useState(false);
  const [is_loading_neutral, setLoadingNeutral] = useState(false);
  const [is_loading_ai, setLoadingAi] = useState(false);
  const [show_global_image_modal, showGlobalImageModal] = useState(false);
  const [show_delete_image_modal, showDeleteModal] = useState(false);
  const [show_upload_image_modal, showUploadModal] = useState(false);
  const [show_preview_image_modal, showPreviewModal] = useState(false);
  const [show_edit_file_name_modal, showEditFileNameModal] = useState(false);

  const image_url = `${url}${image}`;

  const [file_name, file_ext] = (image_filename || "brak_nazwy").split(".");

  const toggleNeutral = async () => {
    try {
      setLoadingNeutral(true);
      await handleSetProductNeutralImage(id, !is_neutral);
      setLoadingNeutral(false);
    } catch (error) {
      setLoadingNeutral(false);
    }
  };

  const toggleForBundle = async () => {
    try {
      setLoadingForBundle(true);
      await handleSetProductForBundleImage(id, !is_for_bundle);
      setLoadingForBundle(false);
    } catch (error) {
      setLoadingForBundle(false);
    }
  };

  const toggleAi = async () => {
    if (!handleSetProductAiImage) return;

    try {
      setLoadingAi(true);
      await handleSetProductAiImage(id, !is_generated_by_ai);
      setLoadingAi(false);
    } catch (error) {
      setLoadingAi(false);
    }
  };

  return (
    <>
      {show_edit_file_name_modal && (
        <EditFileNameModal
          onSubmit={async ({ file_name }) => {
            await handleRenameImage(id, file_name);
            showEditFileNameModal(false);
          }}
          handleClose={() => showEditFileNameModal(false)}
          file_ext={file_ext}
          initialValues={{
            file_name,
          }}
          form={`edit_file_name_${id}`}
        />
      )}
      {show_global_image_modal && (
        <GlobalImageModal
          handleClose={() => showGlobalImageModal(false)}
          handleSubmit={() => handleSetGlobalImage(id)}
          product_data={product_data}
          image={image_url}
        />
      )}
      {show_preview_image_modal && (
        <ModalPreview
          src={`${image_url}`}
          handleClose={() => showPreviewModal(false)}
        />
      )}
      {show_delete_image_modal && (
        <ModalDelete
          handleDelete={() =>
            handleDelete(id).then(() => showDeleteModal(false))
          }
          handleClose={() => showDeleteModal(false)}
          name={image_filename}
        />
      )}
      {show_upload_image_modal && (
        <ModalUpload
          headerText="Wgraj zdjęcie"
          handleUpload={(image) => handleUpdate(id, image)}
          handleClose={() => showUploadModal(false)}
          name={`logo`}
          limit={1}
        />
      )}
      <tr>
        <td>
          <div className="form-group">
            <div className="check-group" style={{ margin: 0 }}>
              <input
                id={`image_${id}`}
                type="checkbox"
                checked={is_checked}
                onChange={() => handleSetActiveImage(id)}
              />
              <label
                htmlFor={`image_${id}`}
                className="label-form"
                style={{ minHeight: 16, margin: 0 }}
              />
            </div>
          </div>
        </td>
        <td>
          <button
            type="button"
            className="btn-preview"
            onClick={() => showPreviewModal(true)}
            style={{
              backgroundImage: `url(${image_url})`,
            }}
          />
        </td>
        <td>{id}</td>
        <td>{image_filename || "brak_nazwy"}</td>
        <td>
          <div className="df v-center h-end p-r-20">
            <button
              className={classNames("btn-neutral-image m-r-10", {
                active: is_for_bundle,
              })}
              disabled={is_loading_for_bundle}
              type="button"
              onClick={toggleForBundle}
            >
              {is_loading_for_bundle ? ".." : "B"}
            </button>
            <button
              className={classNames("btn-neutral-image m-r-10", {
                active: is_neutral,
              })}
              disabled={is_loading_neutral}
              type="button"
              onClick={toggleNeutral}
            >
              {is_loading_neutral ? ".." : "N"}
            </button>
            {handleSetProductAiImage && (
              <button
                className={classNames("btn-ai-image m-r-10", {
                  active: is_generated_by_ai,
                })}
                disabled={is_loading_ai}
                type="button"
                onClick={toggleAi}
                title="Wygenerowane przez AI"
              >
                {is_loading_ai ? ".." : "AI"}
              </button>
            )}
            <button
              className="btn-global-image m-r-10"
              style={is_global ? { opacity: "1" } : {}}
              type="button"
              onClick={() => {
                if (!is_global) {
                  showGlobalImageModal(true);
                }
              }}
            >
              <GlobalImageIcon />
            </button>
            <button
              className="btn-icon"
              type="button"
              onClick={() => showEditFileNameModal(true)}
            >
              <EditIcon />
            </button>
            <Button type="upload-icon" onClick={() => showUploadModal(true)} />
            <Button type="delete-bin" onClick={() => showDeleteModal(true)} />
          </div>
        </td>
      </tr>
    </>
  );
};

export default SingleImageRow;
